module.exports = __webpack_public_path__ + "img/SWARM_lg.e50efeb7.png";